<template>
  <v-app>
    <section>
        <v-parallax :src="require('../assets/light-bg.png')">
          <v-layout>
            <v-container>
              <v-layout row wrap justify-center text-xs-center>
                <v-flex xs12 sm4>
                  <h1 class="primary--text">Get started now!</h1>
                  <router-link to="/"><img src="/static/img/foxyjot-logo.png" class="flogo" alt="FoxyJot logo"></router-link>
                  <p class="px-4 primary--text">Signing uo for an account is excellent, but remember based on the security rules for the databse you will not be able to edit/update/delete. Enjoy!</p>
                </v-flex>
                <v-flex xs12 sm6>
                  <form @submit.prevent="userSignUp">
                    <v-layout column>
                      <v-flex>
                        <v-alert type="error" dismissible v-model="alert">
                          {{ error }}
                        </v-alert>
                      </v-flex>
                      <v-flex>
                        <v-text-field
                          name="email"
                          label="Email"
                          id="email"
                          type="email"
                          v-model="email"
                          prepend-icon="contact_mail"
                          required></v-text-field>
                      </v-flex>
                      <v-flex>
                        <v-text-field
                          name="password"
                          label="Password"
                          id="password"
                          type="password"
                          v-model="password"
                          prepend-icon="lock"
                          required></v-text-field>
                      </v-flex>
                      <v-flex>
                        <v-text-field
                          name="confirmPassword"
                          label="Confirm Password"
                          id="confirmPassword"
                          type="password"
                          prepend-icon="check_box"
                          required
                          v-model="passwordConfirm"
                          :rules="[comparePasswords]"
                          ></v-text-field>
                      </v-flex>
                      <v-flex class="text-xs-center" mt-5>
                        <v-btn color="primary" type="submit" :disabled="loading">Sign Up</v-btn>
                      </v-flex>
                    </v-layout>
                  </form>
                </v-flex>
              </v-layout>
            </v-container>
          </v-layout>
        </v-parallax>
    </section>
  </v-app>
</template>

<script>
export default {
  name: 'ureg',
  data () {
    return {
      email: '',
      password: '',
      passwordConfirm: '',
      alert: false
    }
  },
  computed: {
    comparePasswords () {
      return this.password === this.passwordConfirm ? true : 'Passwords don\'t match'
    },
    error () {
      return this.$store.state.error
    },
    loading () {
      return this.$store.state.loading
    }
  },
  methods: {
    userSignUp () {
      if (this.comparePasswords !== true) {
        return
      }
      this.$store.dispatch('userSignUp', { email: this.email, password: this.password })
    }
  },
  watch: {
    error (value) {
      if (value) {
        this.alert = true
      }
    },
    alert (value) {
      if (!value) {
        this.$store.commit('setError', null)
      }
    }
  }
}
</script>

<style lang="sass">
@import '../styles/index.sass'
.flogo
  width: 100%
  max-width: 100px
</style>



// WEBPACK FOOTER //
// src/app/pages/Signup.vue